import { render, staticRenderFns } from "./staff-pane.vue?vue&type=template&id=8e0d9234&scoped=true"
import script from "./staff-pane.vue?vue&type=script&lang=ts"
export * from "./staff-pane.vue?vue&type=script&lang=ts"
import style0 from "./staff-pane.vue?vue&type=style&index=0&id=8e0d9234&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e0d9234",
  null
  
)

export default component.exports